"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClient = generateClient;
const adapter_core_1 = require("@aws-amplify/core/internals/adapter-core");
const server_1 = require("../internals/server");
const types_1 = require("../types");
/**
 * Generates an GraphQL API client that works with Amplify server context.
 *
 * @example
 * import config from './amplifyconfiguration.json';
 * import { listPosts } from './graphql/queries';
 *
 * const client = generateServerClient({ config });
 *
 * const result = await runWithAmplifyServerContext({
 *   nextServerContext: { request, response },
 *   operation: (contextSpec) => client.graphql(contextSpec, {
 *     query: listPosts,
 *   }),
 * });
 */
function generateClient(options) {
    // passing `null` instance because each (future model) method must retrieve a valid instance
    // from server context
    const client = (0, server_1.generateClientWithAmplifyInstance)({
        amplify: null,
        ...options,
    });
    // TODO: improve this and the next type
    const prevGraphql = client.graphql;
    const wrappedGraphql = (contextSpec, innerOptions, additionalHeaders) => {
        const amplifyInstance = (0, adapter_core_1.getAmplifyServerContext)(contextSpec).amplify;
        return prevGraphql.call({ [types_1.__amplify]: amplifyInstance }, innerOptions, additionalHeaders);
    };
    client.graphql = wrappedGraphql;
    return client;
}
